export const buildPersonListQuery = ({ skip = 0, limit, language, owned }) => ({
	skip,
	limit,
	language,
	...(owned ? { owned: true } : {}),
});
